import InlineMessage from "@ingka/inline-message";
import SSRIcon from "@ingka/ssr-icon";
import crossSmall from "@ingka/ssr-icon/paths/cross-small";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/hyperlink/style.scss";
import "@ingka/inline-message/style.scss";
import "@ingka/focus/style.scss";
import "./CustomInlineToast.scss";

const CustomInlineToast = ({
  visible,
  title,
  body,
  variant,
  onClose,
  icon,
}) => {
  const handleCloseBtnClick = () => {
    onClose();
  };
  return (
    <div className="custom-inline-toast-container">
      {visible && (
        <div className="custom-inline-toast">
          <InlineMessage
            link="#"
            title={title}
            variant={variant}
            body={body}
            ssrIcon={icon ?? null}
          />
          <div className="close-button-container">
            <div className="close-button" onClick={handleCloseBtnClick}>
              <SSRIcon className="forward-arrow-icon" paths={crossSmall} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomInlineToast;
